import { Breakpoint, useTheme } from '@mui/material';

export const useIsTablet = (cb: Breakpoint) => {
  const theme = useTheme();

  return (
    theme.breakpoints.values[cb] < theme.breakpoints.values['laptop'] &&
    theme.breakpoints.values[cb] >= theme.breakpoints.values['tablet']
  );
};
